import React, { FC, PropsWithChildren } from 'react';

interface ILinkProps {
  className: string;
  href: string;
}

export const Link: FC<PropsWithChildren<ILinkProps>> = ({ children, className, href }) => (
  <a className={className} href={href}>
    {children}
  </a>
);
